export default __webpack_public_path__ + "static/media/coding.b29dd865.png";